// extracted by mini-css-extract-plugin
export default {"container":"CoursePreview_container__Q4-55"};